/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DeleteStaffInputDto interface.
 */
export function instanceOfDeleteStaffInputDto(value) {
    return true;
}
export function DeleteStaffInputDtoFromJSON(json) {
    return DeleteStaffInputDtoFromJSONTyped(json, false);
}
export function DeleteStaffInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userIdToDelete': json['userIdToDelete'] == null ? undefined : json['userIdToDelete'],
    };
}
export function DeleteStaffInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'userIdToDelete': value['userIdToDelete'],
    };
}
